import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NgClass, NgTemplateOutlet, AsyncPipe, DatePipe } from '@angular/common';
import { DeviceService, SdHtmlComponent, SdModalDefaultComponent } from '@seb/web-design-system/core';
import { OneySimulation } from '../../../models';
import { BaseStoreService } from '../../../services';

@Component({
  selector: 'wc-oney-modal',
  templateUrl: './oney-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdModalDefaultComponent,
    NgClass,
    NgTemplateOutlet,
    AsyncPipe,
    DatePipe,
    TranslatePipe,
    SdHtmlComponent
  ]
})
export class OneyModalComponent implements OnChanges {
  currentSimulation = [];
  activeTab = 0;
  customerLabel = '';
  currentSimulationType = '';
  paragraph1 = '';
  paragraph2 = '';
  paragraph3 = '';
  footer = '';
  isSimulationUnavailable = false;
  isDesktop$: Observable<boolean>;
  isTablet$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  @Input() isOpenedOneyModal = false;
  @Input() productCode = '';
  @Input() bundleId = '';
  @Input() currentUser = '';
  @Input() currentCart = '';

  @Output()
  isOpenedOneyModalChange = new EventEmitter<boolean>();

  constructor(
    private deviceService: DeviceService,
    private baseStore: BaseStoreService,
    private cdRef: ChangeDetectorRef,
    private translateService: TranslateService
  ) {
    this.isDesktop$ = this.deviceService.isDesktop;
    this.isTablet$ = this.deviceService.isTablet;
    this.isMobile$ = this.deviceService.isMobile;
  }

  @Output()
  setActiveTab(index: number, isMobile: boolean, simulationType: string): void {
    if (this.activeTab === index && isMobile) {
      this.activeTab = -1;
    } else {
      this.currentSimulationType = simulationType?.toLowerCase();
      this.setFooterValues();
      this.activeTab = index;
    }
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.isSimulationUnavailable = false;

    // TODO-EL: refactoriser tout ça, que de duplication de code !! DRY
    if (this.isOpenedOneyModal) {

      if (this.productCode) {
        this.baseStore.getOneySimulationsProduct(this.productCode).subscribe({
          next: (simulationProduct: OneySimulation) => {
            this.currentSimulation = simulationProduct.simulations || [];

            this.currentSimulationType =
              this.currentSimulation[this.activeTab === -1 ? 0 : this.activeTab]?.type?.toLowerCase() ?? '';

            this.setFooterValues();
            this.cdRef.markForCheck();
          },
          error: () => {
            this.isSimulationUnavailable = true;
            this.cdRef.markForCheck();
          }
        });
      }

      if (this.bundleId) {
        this.baseStore.getOneySimulationsBundle(this.bundleId).subscribe({
          next: (simulationProduct: OneySimulation) => {
            this.currentSimulation = simulationProduct.simulations || [];

            this.currentSimulationType =
              this.currentSimulation[this.activeTab === -1 ? 0 : this.activeTab]?.type?.toLowerCase() ?? '';

            this.setFooterValues();
            this.cdRef.markForCheck();
          },
          error: () => {
            this.isSimulationUnavailable = true;
            this.cdRef.markForCheck();
          }
        });
      }

      if (this.currentUser && this.currentCart) {
        this.baseStore.getOneySimulationsCart(this.currentUser, this.currentCart).subscribe({
          next: (simulationCart: OneySimulation) => {
            this.currentSimulation = simulationCart.simulations || [];

            this.currentSimulationType =
              this.currentSimulation[this.activeTab === -1 ? 0 : this.activeTab]?.type?.toLowerCase() ?? '';

            this.setFooterValues();
            this.cdRef.markForCheck();
          },
          error: () => {
            this.isSimulationUnavailable = true;
            this.cdRef.markForCheck();
          }
        });
      }
    }
  }

  setFooterValues(): void {
    const keyP1 = `oney.simulation.footer.${this.currentSimulationType}.paragraph1`;
    const keyP2 = `oney.simulation.footer.${this.currentSimulationType}.paragraph2`;
    const keyP3 = `oney.simulation.footer.${this.currentSimulationType}.paragraph3`;
    const keyFooter = `oney.simulation.footer.${this.currentSimulationType}.text`;

    const defaultKeyP1 = 'oney.simulation.footer.paragraph1';
    const defaultKeyP2 = 'oney.simulation.footer.paragraph2';
    const defaultKeyP3 = 'oney.simulation.footer.paragraph3';
    const defaultKeyFooter = 'oney.simulation.footer.text';

    this.paragraph1 = this.getPropertyValue(keyP1, defaultKeyP1);
    this.paragraph2 = this.getPropertyValue(keyP2, defaultKeyP2);
    this.paragraph3 = this.getPropertyValue(keyP3, defaultKeyP3);
    this.footer = this.getPropertyValue(keyFooter, defaultKeyFooter);
  }

  getPropertyValue(key: string, defaultKey: string): string {
    const value = this.translateService.instant(key);
    return value !== key ? value : this.translateService.instant(defaultKey);
  }

  modalClosed(isOpened: boolean): void {
    if (!isOpened) {
      this.isOpenedOneyModalChange.emit(false);
      this.isOpenedOneyModal = false;
      this.currentSimulation = [];
    }
  }
}
